export function cleanObject(obj) {
    if (Array.isArray(obj)) {
      return obj
        .map(cleanObject)
        .filter(item => item !== null && item !== '' && !(typeof item === 'object' && Object.keys(item).length === 0));
    } else if (typeof obj === 'object' && obj !== null) {
      const newObj = {};
      for (const key in obj) {
        const cleaned = cleanObject(obj[key]);
        if (
          cleaned !== null &&
          cleaned !== '' &&
          !(typeof cleaned === 'object' && Object.keys(cleaned).length === 0)
        ) {
          newObj[key] = cleaned;
        }
      }
      return newObj;
    } else {
      return obj;
    }
  }

